import React, { useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import ReactHtmlParser from 'react-html-parser';

import { get360Data, goToTop, setCursorWaiting, hideCmsHiddenBlock, getLoading } from '../../../utils';

import { SummaryConstants as Constants } from '../../../Helpers/summaryconstants';
import SummaryCalculator from '../../../Helpers/summarycalculator';
import GTMHelper from '../../../Helpers/gtmHelper';
import NavHelper from '../../../Helpers/navhelper';

import { Nav } from '../../3_Organisms/Nav/Nav';
import Button from '../../1_Atoms/Button/Button';
import WheelsList from '../../3_Organisms/WheelsList/WheelsList';
import { WheelsImageContainer } from '../../3_Organisms/WheelsImageContainer/WheelsImageContainer';
import { Pricing } from '../../3_Organisms/Pricing/Pricing';
import { Modal } from '../../3_Organisms/Modal/Modal';
import { PreOrderModal } from '../../3_Organisms/Modal/PreOrderModal';
import { Alert } from '../../3_Organisms/Alert/Alert';

export const Wheels = ({ ...props }) => {
    const [loading, setLoading] = useState(true);
    const summaryCalculator = window.summaryCalculator;
    const { year, carline, trim, model, packageCode } = useParams();
    const [nav, setNav] = React.useState(null);
    const navigate = useNavigate();
    const listRef = React.useRef();
    const legalContent = JSON.parse(sessionStorage.getItem('LegalWheels'));
    const [legalModalOpen, setLegalModalOpen] = React.useState(false);
    const { t, i18n } = useTranslation(['wheels', 'general']);
    const [images, setImages] = useState({});
    const [bgImage, setbgImage] = useState(null);
    const [fgImage, setfgImage] = useState(null);
    const [selectedWheelIndex, setSelectedWheelIndex] = useState(summaryCalculator.SelectedWheelIndex);
    const [showFinancePrice, setShowFinancePrice] = React.useState(summaryCalculator.ShowFinancePrice);

    const [preorderOpen, setPreorderModalOpen] = React.useState(false);
    
	const gtmHelper = new GTMHelper();
    const navHelper = new NavHelper();
    
	let selectedWheelObject;

    const selectedColor = useMemo(() => {
        const storageColor = sessionStorage.getItem(Constants.SelectedExteriorColour);
        return storageColor ? JSON.parse(storageColor).code : summaryCalculator.Wheels?.visual.interiors[0].default_exterior.code;
    }, [summaryCalculator.Wheels]);

    hideCmsHiddenBlock();

    summaryCalculator.CurrentStep = 4;

    React.useEffect(() => {
        async function executeTasks() {
            if (!summaryCalculator.isDataLoaded()) {
                await summaryCalculator.loadVehicleData(year, carline, trim, model, packageCode);
                await summaryCalculator.loadFromFinancialProvider();

                setLoading(false);

                setSelectedWheelIndex(summaryCalculator.SelectedWheelIndex);
            } else {
                setLoading(false);
            }

            if (!loading) {
                if (nav === null) {
                    const toRender = navHelper.getNavContent(t);
                    setNav(toRender);   
                    //setNav(navHelper.getNavContent(year, carline, trim, model, packageCode, summaryCalculator.CurrentStep, t));
                }
            }    

            if (listRef.current) {
                setListMaxHeight();
            }
        }

        executeTasks();
    }, [summaryCalculator, nav, loading]);

    async function handleSelectedWheel(index) {
        setCursorWaiting(true);

        await summaryCalculator.setSelectedWheelIndex(index);

        setSelectedWheelIndex(index);

        setCursorWaiting(false);

		gtmHelper.setGTM({'action':'Selected Wheel'}, false, false);
    }

    function nextStep() {
        goToTop();
        //navigate(`/${year}/${carline}/${trim}/${model}/${packageCode}/connectivity${decodeURI(window.location.search)}`);
        navigate(`/${year}/${carline}/${trim}/${model}/${packageCode}/accessories${decodeURI(window.location.search)}`)
		gtmHelper.setGTM({'action':'Next Step'}, true , false);
    }

    function setListMaxHeight() {
        if (listRef.current){
            if (window.innerWidth < 1025) {
                listRef.current.style.height = 'unset';
            } else {
                const incentivebar = document.querySelector('.mz-alert__item'); // Red alert bar

                listRef.current.style.height = `${window.innerHeight - (document.querySelector(".mz-sticky-submenu")?.offsetTop + document.querySelector(".mz-sticky-submenu")?.offsetHeight + document.querySelector(".mz-pricing")?.offsetHeight + (incentivebar ? incentivebar.offsetHeight : 0) + 30)}px`;
            }
		}

	}


    if (summaryCalculator.Wheels && !images) {
        setImages(get360Data(summaryCalculator.Wheels.visual, model));
    }

    if (summaryCalculator.Wheels && summaryCalculator.Wheels.wheels) {
        // Set Wheel Images
        const yearSlug = summaryCalculator.Wheels.year.url_slug;
        const carlineSlug = summaryCalculator.Wheels.carline.url_slug;
        const trimSlug = summaryCalculator.Wheels.trim.trim_type.url_slug ? summaryCalculator.Wheels.trim.trim_type.url_slug : summaryCalculator.Wheels.trim.trim_type.name;
        const wheelImageBaseURL = `${summaryCalculator.Wheels.visual.static_content_base_path}/wheels/${yearSlug}/${carlineSlug}/`;
        const bgImagePath = summaryCalculator.SelectedColourInterior && summaryCalculator.SelectedColourInterior.include_in_360 ? `${wheelImageBaseURL}${yearSlug}-${carlineSlug}-${trimSlug.replaceAll(' ', '')}-${selectedColor}-${summaryCalculator.SelectedColourInterior.code}-WHEELS.jpg` : `${wheelImageBaseURL}${yearSlug}-${carlineSlug}-${trimSlug.replaceAll(' ', '')}-${selectedColor}-WHEELS.jpg`;
        if (bgImage !== bgImagePath)
            setbgImage(bgImagePath);

        selectedWheelObject = summaryCalculator.Wheels.wheels[Object.keys(summaryCalculator.Wheels.wheels)[selectedWheelIndex]];
        if (selectedWheelObject) {
            const fgImagePath = `${wheelImageBaseURL}${yearSlug}-${carlineSlug}-WHEELS-${selectedWheelObject.image.overlay_image_suffix}.png`;
            if(fgImage !== fgImagePath)
                setfgImage(fgImagePath);
        }
    }

    function handleShowFinanceClick(value) {
        setShowFinancePrice(value);
    }

    return (
        <>
        {getLoading(false, t)}
        <div className="mz-wheels-page mz-top-nav-spacing">
            <Nav nav={nav} />
            <Alert />

            {summaryCalculator.Wheels?.wheels ?
                <div key='0' className="mz-full-width mz-wheels-page__content general-content">
                    <div className="mz-wheels-page__content-left">
                        <WheelsImageContainer trimName={summaryCalculator.VehicleTitle} imageBackgroundCar={bgImage} imageForegroundWheel={selectedWheelObject?fgImage:''} />
                    </div>
                    <div className="mz-wheels-page__content-right right-container">
                        <div className="mz-wheels-page__wheels-card-list" ref={listRef}>
                            <h5 className='mz-wheels-page__wheels-card-list-title'>{ReactHtmlParser(t("select_wheels"))}</h5>

                            <WheelsList Wheels={summaryCalculator.Wheels.wheels} SelectedIndex={selectedWheelIndex} DisabledIndexes={[]} HandleSelectedWheel={handleSelectedWheel} defaultWheelSize={summaryCalculator.Wheels.default_wheels_size} showFinancePrice={showFinancePrice}></WheelsList>

                            <div className="mz-legal mz-mobile">
                                <Button
                                    className="mz-btn mz-btn--legal text--grey"
                                    label={t("general:legal")}
                                    backgroundColor="grey"
                                    colour="grey"
                                    icon={true}
                                    iconAfter={true}
                                    svg_className=""
                                    svg_list="plus"
                                    size={0.6}
                                    onClick={() => {
										document.querySelector('body').classList.add('disabled');
										setLegalModalOpen(true)}}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                : null}
            {summaryCalculator.Wheels?.wheels ?
                <Pricing builtLabel={t("general:price_as_built")} builtPrice="$" loanLabel={t("general:loan_label")} loanPrice="$" saveLabel={t("general:save_build")}
                    leaseLabel={t("general:show_lease_price")} financeLabel={t("general:show_finance_price")} buttonLabel={t("general:next_accessories")} summaryCalculator={summaryCalculator}
                    HandleNextClick={nextStep} setLegalModalOpen={setLegalModalOpen} HandleShowFinanceClick={handleShowFinanceClick} setPreorderModalOpen={setPreorderModalOpen} /> : null}
            <Modal modalContent={legalContent} isOpen={legalModalOpen} handleClose={setLegalModalOpen} modalId='legalModal' />
            <PreOrderModal isOpen={preorderOpen} handleClose={setPreorderModalOpen}></PreOrderModal> 
        </div>
        </>
    )
}

export default Wheels;